@let loading = (loading$ | async)!;
@let company = company$ | async;
@let user = user$ | async;
<form class="form" [formGroup]="formGroup" (ngSubmit)="submitForm()">
  @let form = formGroup;
  <p-card>
    <ng-template #title>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6">
          <p-breadcrumb
            [model]="[
              {
                icon: 'fa fa-id-card  fa-fw',
                label: 'sidebar.companyProfile' | translate,
                routerLink: '/admin/companies',
              },
              { label: company?.naam },
            ]"
          ></p-breadcrumb>
        </div>
        <div class="col-span-6 flex items-center justify-end gap-2">
          <p-button
            severity="success"
            iconPos="left"
            [label]="'buttons.saveSingle' | translate"
            type="submit"
            [disabled]="
              !formGroup.valid ||
              !reportColorFormGroup.valid ||
              !hasPermission('write', globalRolePermissionsParams(user, 'companyProfile'))
            "
          >
            <ng-template #icon>
              <fa-icon [icon]="faSave"></fa-icon>
            </ng-template>
          </p-button>
        </div>
      </div>
    </ng-template>

    @if (showForm) {
      <div class="p-fluid relative">
        @if (loading) {
          <div class="absolute inset-0 z-10 flex items-center justify-center">
            <div class="bg-surface-0 absolute inset-0 opacity-60"></div>
            <fa-icon [icon]="faSpinner" animation="spin" size="2xl" class="relative"></fa-icon>
          </div>
        }
        <div class="grid grid-cols-12 gap-6">
          <div class="col-span-12 flex flex-col gap-5 pt-2 lg:col-span-7">
            <div>
              @let fieldNaam = 'naam';
              <p-floatlabel variant="on">
                <input [id]="fieldNaam" pInputText type="text" [formControlName]="fieldNaam" />
                <label [htmlFor]="fieldNaam">
                  {{ ('fields.name' | translate) + (form.controls[fieldNaam] | isRequired) }}
                  <span class="error">{{ form.controls[fieldNaam] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div>
              @let fieldTlf = 'tlf';
              <p-floatlabel variant="on">
                <input [id]="fieldTlf" pInputText type="text" [formControlName]="fieldTlf" />
                <label [htmlFor]="fieldTlf">
                  {{ ('fields.telephone' | translate) + (form.controls[fieldTlf] | isRequired) }}
                  <span class="error">{{ form.controls[fieldTlf] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div>
              @let fieldEmail = 'email';
              <p-floatlabel variant="on">
                <input [id]="fieldEmail" pInputText type="text" [formControlName]="fieldEmail" />
                <label [htmlFor]="fieldEmail">
                  {{ ('fields.email' | translate) + (form.controls[fieldEmail] | isRequired) }}
                  <span class="error">{{ form.controls[fieldEmail] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div>
              @let fieldWebsite = 'website';
              <p-floatlabel variant="on">
                <input [id]="fieldWebsite" pInputText type="text" [formControlName]="fieldWebsite" />
                <label [htmlFor]="fieldWebsite">
                  {{ ('fields.website' | translate) + (form.controls[fieldWebsite] | isRequired) }}
                  <span class="error">{{ form.controls[fieldWebsite] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div>
              @let fieldAddress = 'address';
              <p-floatlabel variant="on">
                <input [id]="fieldAddress" pInputText type="text" [formControlName]="fieldAddress" />
                <label [htmlFor]="fieldAddress">
                  {{ ('fields.address' | translate) + (form.controls[fieldAddress] | isRequired) }}
                  <span class="error">{{ form.controls[fieldAddress] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div class="grid grid-cols-12 gap-2">
              <div class="col-span-12 md:col-span-3">
                @let fieldPostcode = 'postcode';
                <p-floatlabel variant="on">
                  <input [id]="fieldPostcode" pInputText type="text" [formControlName]="fieldPostcode" />
                  <label [htmlFor]="fieldPostcode">
                    {{ ('fields.postalCode' | translate) + (form.controls[fieldPostcode] | isRequired) }}
                    <span class="error">{{ form.controls[fieldPostcode] | errors | async }}</span>
                  </label>
                </p-floatlabel>
              </div>
              <div class="col-span-12 md:col-span-9">
                @let fieldPlace = 'place';
                <p-floatlabel variant="on">
                  <input [id]="fieldPlace" pInputText type="text" [formControlName]="fieldPlace" />
                  <label [htmlFor]="fieldPlace">
                    {{ ('fields.place' | translate) + (form.controls[fieldPlace] | isRequired) }}
                    <span class="error">{{ form.controls[fieldPlace] | errors | async }}</span>
                  </label>
                </p-floatlabel>
              </div>
            </div>
            <div>
              @let fieldMailingAddress = 'mailingAddress';
              <p-floatlabel variant="on">
                <input [id]="fieldMailingAddress" pInputText type="text" [formControlName]="fieldMailingAddress" />
                <label [htmlFor]="fieldMailingAddress">
                  {{ ('fields.mailingAddress' | translate) + (form.controls[fieldMailingAddress] | isRequired) }}
                  <span class="error">{{ form.controls[fieldMailingAddress] | errors | async }}</span>
                </label>
              </p-floatlabel>
            </div>
            <div class="grid grid-cols-12 gap-2">
              <div class="col-span-12 md:col-span-3">
                @let fieldMailingPostcode = 'mailingPostcode';
                <p-floatlabel variant="on">
                  <input [id]="fieldMailingPostcode" pInputText type="text" [formControlName]="fieldMailingPostcode" />
                  <label [htmlFor]="fieldMailingPostcode">
                    {{ ('fields.mailingPostcode' | translate) + (form.controls[fieldMailingPostcode] | isRequired) }}
                    <span class="error">{{ form.controls[fieldMailingPostcode] | errors | async }}</span>
                  </label>
                </p-floatlabel>
              </div>
              <div class="col-span-12 md:col-span-9">
                @let fieldMailingPlace = 'mailingPlace';
                <p-floatlabel variant="on">
                  <input [id]="fieldMailingPlace" pInputText type="text" [formControlName]="fieldMailingPlace" />
                  <label [htmlFor]="fieldMailingPlace">
                    {{ ('fields.mailingPlace' | translate) + (form.controls[fieldMailingPlace] | isRequired) }}
                    <span class="error">{{ form.controls[fieldMailingPlace] | errors | async }}</span>
                  </label>
                </p-floatlabel>
              </div>
            </div>
          </div>
          <div class="col-span-12 lg:col-span-5">
            <div class="companyLogo flex h-full flex-col gap-3 pt-2">
              <div class="flex flex-wrap items-center justify-between gap-2">
                <div class="text-surface-700 flex items-center gap-2">
                  <fa-icon [icon]="faImage"></fa-icon>
                  <span class="text-md font-medium">{{ 'companyProfile.companyLogo.title' | translate }}</span>
                </div>
                <div class="flex items-center gap-2">
                  <p-fileUpload
                    #fileUpload
                    [disabled]="
                      formGroup.disabled ||
                      loading ||
                      loadingLogo() ||
                      uploadingLogo() ||
                      deletingLogo() ||
                      !company ||
                      !company.id
                    "
                    name="logo"
                    [auto]="true"
                    [customUpload]="true"
                    mode="basic"
                    accept="image/png,image/jpg,image/jpeg"
                    [chooseLabel]="'upload' | translate"
                    (uploadHandler)="uploadLogo($event, fileUpload)"
                  >
                    <ng-template #chooseicon>
                      @if (uploadingLogo()) {
                        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                      } @else {
                        <fa-icon [icon]="faUpload"></fa-icon>
                      }
                    </ng-template>
                  </p-fileUpload>
                  @if (imageSrc) {
                    <p-button
                      severity="danger"
                      type="button"
                      [outlined]="true"
                      [label]="'buttons.deleteSingle' | translate"
                      [disabled]="formGroup.disabled || loadingLogo() || uploadingLogo() || deletingLogo()"
                      [loading]="deletingLogo()"
                      (onClick)="deleteLogo(fileUpload)"
                    >
                      <ng-template #icon>
                        <fa-icon [icon]="faTrash"></fa-icon>
                      </ng-template>
                      <ng-template #loadingicon>
                        <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                      </ng-template>
                    </p-button>
                  }
                </div>
              </div>
              <div
                class="logoImageContainer border-surface-300 bg-surface-0 relative flex min-h-40 w-full flex-1 items-center justify-center overflow-hidden rounded-lg border shadow-xs"
                [class.border-dashed]="!imageSrc"
              >
                @if (imageSrc) {
                  <img [src]="imageSrc" alt="logo" class="absolute inset-0 h-full w-full object-contain p-3" />
                } @else {
                  <div class="text-surface-400 flex flex-col items-center gap-2 p-4 text-center">
                    <fa-icon [icon]="faImage" class="text-4xl opacity-70"></fa-icon>
                    <span class="text-xs">{{ 'companyProfile.companyLogo.empty' | translate }}</span>
                  </div>
                }

                @if (loadingLogo()) {
                  <div class="bg-surface-0 absolute inset-0 flex items-center justify-center">
                    <fa-icon [icon]="faSpinner" animation="spin" size="2xl"></fa-icon>
                  </div>
                } @else if (uploadingLogo() || deletingLogo()) {
                  <div class="bg-surface-0 absolute inset-0 opacity-50"></div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </p-card>

  @if (userRoles | includes: 'admin') {
    <p-card styleClass="mt-6">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-6">
          <div class="col-span-12 mt-8 p-0">
            @let fieldLicentie = 'licentie';
            <p-floatlabel variant="on">
              <input [id]="fieldLicentie" pInputText type="text" class="" [formControlName]="fieldLicentie" />
              <label [htmlFor]="fieldLicentie">
                {{ ('fields.license' | translate) + (form.controls[fieldLicentie] | isRequired) }}
                <span class="error">{{ form.controls[fieldLicentie] | errors | async }}</span>
              </label>
            </p-floatlabel>
          </div>
          <div class="col-span-12 mt-8 p-0">
            @let fieldIsopdrachtgever = 'isopdrachtgever';
            <span class="flex items-center gap-2">
              <span>
                {{ ('fields.isClient' | translate) + (form.controls[fieldIsopdrachtgever] | isRequired) }}
                <span class="error">{{ form.controls[fieldIsopdrachtgever] | errors | async }}</span>
              </span>
              <p-inputSwitch
                [formControlName]="fieldIsopdrachtgever"
                [inputId]="fieldIsopdrachtgever"
                [id]="fieldIsopdrachtgever"
                styleClass="mt-2"
              ></p-inputSwitch>
            </span>
          </div>
        </div>
        <div class="col-span-2">
          <h3 class="m-0 p-0">{{ 'fields.modules' | translate }}</h3>
          <div class="flex flex-col gap-2">
            @for (module of modules; track module) {
              <div class="flex gap-2">
                <p-checkbox
                  name="group"
                  [value]="module.value"
                  formControlName="modules"
                  [inputId]="module.value"
                ></p-checkbox>
                <label [for]="module.value">
                  <fa-icon [icon]="module.icon" size="xl" [style]="{ color: module.color }"></fa-icon>
                  {{ module.name }}
                </label>
              </div>
            }
          </div>
        </div>
        <div class="col-span-2">
          <h3 class="m-0 p-0">{{ 'fields.categories' | translate }}</h3>
          <div class="flex flex-col gap-2">
            @for (category of categories; track category) {
              <div class="flex gap-2">
                <p-checkbox
                  name="group"
                  [value]="category.value"
                  formControlName="categorien"
                  [inputId]="category.value"
                ></p-checkbox>
                <label [for]="category.value">
                  <fa-icon [icon]="category.icon" size="xl"></fa-icon>
                  {{ category.name }}
                </label>
              </div>
            }
          </div>
        </div>
        <div class="col-span-2">
          <h3 class="m-0 p-0">{{ 'fields.modules' | translate }}</h3>
          <div class="flex flex-col gap-2">
            @for (module of extraModules; track module) {
              <div class="flex gap-2">
                <p-checkbox
                  name="group"
                  [value]="module.value"
                  formControlName="modules"
                  [inputId]="module.value"
                ></p-checkbox>
                <label [for]="module.value">
                  <fa-icon [icon]="module.icon" size="xl" [style]="{ color: module.color }"></fa-icon>
                  {{ module.name }}
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    </p-card>
  }
</form>

@if (company && company.id) {
  <p-card styleClass="mt-6">
    <ng-template #title>
      <div class="flex">
        {{ 'contactPersons' | translate }}
        <div class="grow"></div>
        <app-add-new-button
          [parentContext]="this"
          [disabled]="
            (mode === 'company-profile' &&
              !hasPermission('write', globalRolePermissionsParams(user, 'companyProfile'))) ||
            loading
          "
        ></app-add-new-button>
      </div>
    </ng-template>
    <app-agnostic-grids
      [dependencies]="gridDependencies"
      (gridApiChange)="onPersonGridApiChange($event)"
      [loading]="loading"
    ></app-agnostic-grids>
  </p-card>
  <p-card styleClass="mt-6">
    <ng-template #title>
      <div class="cardTitle">
        <div class="flex items-center gap-2 pb-2">
          <fa-icon [icon]="faGear" size="lg"></fa-icon>
          <span class="text-2xl font-semibold">{{ 'companyProfile.reportSettings' | translate }}</span>
        </div>
      </div>
    </ng-template>

    <div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
      <section class="border-surface-200 bg-surface-50 flex flex-col rounded-xl border p-5">
        <header class="text-surface-700 mb-4 flex items-center gap-2">
          <fa-icon [icon]="faPalette"></fa-icon>
          <span class="text-xl font-semibold">{{ 'companyProfile.reportColorsSection' | translate }}</span>
        </header>

        <form [formGroup]="reportColorFormGroup" class="flex flex-col gap-3">
          <div
            class="border-surface-200 bg-surface-0 flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5"
          >
            <label for="title" class="text-surface-700 text-sm font-medium">
              {{ 'companyProfile.reportSettingTitle' | translate }}
            </label>
            <div class="flex items-center gap-2">
              <p-colorpicker inputId="title" formControlName="titleColor" format="hex" />
              <input
                pInputText
                type="text"
                pSize="small"
                formControlName="titleColor"
                class="w-28 text-center font-mono text-sm uppercase"
              />
            </div>
          </div>

          <div
            class="border-surface-200 bg-surface-0 flex items-center justify-between gap-3 rounded-lg border px-3 py-2.5"
          >
            <label for="subtitle" class="text-surface-700 text-sm font-medium">
              {{ 'companyProfile.reportSettingSubtitle' | translate }}
            </label>
            <div class="flex items-center gap-2">
              <p-colorpicker inputId="subtitle" formControlName="subtitleColor" format="hex" />
              <input
                pInputText
                type="text"
                pSize="small"
                formControlName="subtitleColor"
                class="w-28 text-center font-mono text-sm uppercase"
              />
            </div>
          </div>
        </form>

        <div class="mt-auto flex justify-end pt-4">
          <p-button
            [label]="'buttons.reset' | translate"
            severity="secondary"
            variant="outlined"
            (onClick)="resetColors()"
          >
            <ng-template #icon>
              <fa-icon [icon]="faUndo"></fa-icon>
            </ng-template>
          </p-button>
        </div>
      </section>

      <section class="border-surface-200 bg-surface-50 flex flex-col rounded-xl border p-5">
        <header class="text-surface-700 mb-4 flex items-center gap-2">
          <fa-icon [icon]="faImage"></fa-icon>
          <span class="text-xl font-semibold">{{ 'companyProfile.companyBackground.title' | translate }}</span>
        </header>

        <div class="flex flex-col gap-5 sm:flex-row sm:items-stretch">
          <div
            class="border-surface-300 bg-surface-0 relative flex aspect-210/297 w-36 shrink-0 items-center justify-center self-center overflow-hidden rounded-lg border shadow-xs sm:self-start"
            [class.border-dashed]="!companyBackgroundImageSrc()"
          >
            @if (companyBackgroundImageSrc(); as bgSrc) {
              <img [src]="bgSrc" alt="A4" class="h-full w-full object-contain" />
            } @else {
              <div class="text-surface-400 flex flex-col items-center gap-2 p-4 text-center">
                <fa-icon [icon]="faImage" class="text-4xl opacity-70"></fa-icon>
                <span class="text-xs">{{ 'companyProfile.companyBackground.empty' | translate }}</span>
              </div>
            }

            @if (loadingCompanyBackground()) {
              <div class="bg-surface-0 absolute inset-0 flex items-center justify-center">
                <fa-icon [icon]="faSpinner" animation="spin" size="2xl"></fa-icon>
              </div>
            } @else if (uploadingCompanyBackground() || deletingCompanyBackground()) {
              <div class="bg-surface-0 absolute inset-0 opacity-50"></div>
            }
          </div>

          <div class="flex flex-1 flex-col gap-2">
            <p class="text-surface-600 text-md m-0">
              {{ 'companyProfile.companyBackground.description' | translate }}
            </p>
            <p class="text-surface-600 bg-surface-100 m-0 flex items-start gap-2 rounded-md px-2.5 py-2 text-sm">
              <fa-icon [icon]="faImage" class="mt-0.5"></fa-icon>
              <span>
                {{
                  'companyProfile.companyBackground.a4Hint'
                    | translate
                      : {
                          optimalWidth: A4_OPTIMAL_WIDTH,
                          optimalHeight: A4_OPTIMAL_HEIGHT,
                          minWidth: A4_MIN_WIDTH_PX,
                          minHeight: A4_MIN_HEIGHT_PX,
                        }
                }}
              </span>
            </p>

            <div class="mt-auto flex flex-wrap items-center gap-2 pt-2">
              <p-fileUpload
                #bgUpload
                [disabled]="
                  formGroup.disabled ||
                  loading ||
                  !company ||
                  !company.id ||
                  loadingCompanyBackground() ||
                  uploadingCompanyBackground() ||
                  deletingCompanyBackground()
                "
                name="companyBackgroundImage"
                [auto]="true"
                [customUpload]="true"
                mode="basic"
                accept="image/png,image/jpg,image/jpeg"
                [chooseLabel]="'upload' | translate"
                (uploadHandler)="uploadCompanyBackground($event, bgUpload)"
              >
                <ng-template #chooseicon>
                  @if (uploadingCompanyBackground()) {
                    <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                  } @else {
                    <fa-icon [icon]="faUpload"></fa-icon>
                  }
                </ng-template>
              </p-fileUpload>

              @if (companyBackgroundImageSrc()) {
                <p-button
                  severity="danger"
                  type="button"
                  [outlined]="true"
                  [label]="'buttons.deleteSingle' | translate"
                  [disabled]="formGroup.disabled || loadingCompanyBackground() || uploadingCompanyBackground()"
                  (onClick)="deleteCompanyBackground()"
                  [loading]="deletingCompanyBackground()"
                >
                  <ng-template #icon>
                    <fa-icon [icon]="faTrash"></fa-icon>
                  </ng-template>
                  <ng-template #loadingicon>
                    <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                  </ng-template>
                </p-button>
              }
            </div>
          </div>
        </div>
      </section>
    </div>
  </p-card>

  <p-card styleClass="mt-6">
    <ng-template #title>
      <div class="flex items-center gap-2 pb-2">
        <fa-icon [icon]="faPlug" size="lg"></fa-icon>
        <span class="text-2xl font-semibold">{{ 'companyProfile.integrations' | translate }}</span>
      </div>
    </ng-template>

    <form [formGroup]="formGroup">
      <div class="flex flex-col gap-5">
        <section class="border-surface-200 bg-surface-50 rounded-xl border p-5">
          <header class="border-surface-200 mb-4 flex items-center justify-between gap-2 border-b pb-3">
            <span class="text-surface-700 text-xl font-semibold">{{
              'companyProfile.afasApiSettings' | translate
            }}</span>
            <img alt="AFAS" src="assets/images/afas.png" class="integrationImages" />
          </header>
          <div class="p-fluid">
            <div class="grid grid-cols-12 items-center gap-4">
              <div class="col-span-12 md:col-span-6">
                <p-floatlabel variant="on">
                  <p-password formControlName="afasToken" [feedback]="false" [toggleMask]="true" styleClass="w-full" />
                  <label> Afas token </label>
                </p-floatlabel>
              </div>
              <div class="col-span-12 md:col-span-3">
                <p-floatlabel variant="on">
                  <input pInputText type="text" formControlName="afasId" />
                  <label> Afas admin ID </label>
                </p-floatlabel>
              </div>
              <div class="afasCheckbox col-span-12 md:col-span-3">
                <p-checkbox
                  [binary]="true"
                  formControlName="uploadReportsIntegration"
                  inputId="uploadReportsIntegration"
                ></p-checkbox>
                <label for="uploadReportsIntegration">
                  {{ 'companyProfile.afasUploadInspections' | translate }}
                </label>
              </div>
            </div>
          </div>
        </section>

        <section class="border-surface-200 bg-surface-50 rounded-xl border p-5">
          <header class="border-surface-200 mb-4 flex items-center justify-between gap-2 border-b pb-3">
            <span class="text-surface-700 text-xl font-semibold">{{
              'companyProfile.exactApiSettings' | translate
            }}</span>
            <img alt="EXACT" src="assets/images/exact.webp" class="integrationImages" />
          </header>
          <div class="p-fluid">
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12 md:col-span-6">
                <p-floatlabel variant="on">
                  <p-password
                    formControlName="exactApiKey"
                    [feedback]="false"
                    [toggleMask]="true"
                    styleClass="w-full"
                  />
                  <label> Exact API key</label>
                </p-floatlabel>
              </div>
              <div class="col-span-12 md:col-span-6">
                <p-floatlabel variant="on">
                  <input pInputText type="text" formControlName="exactUrl" />
                  <label> Exact url </label>
                </p-floatlabel>
              </div>
            </div>
          </div>
        </section>

        <section class="border-surface-200 bg-surface-50 rounded-xl border p-5">
          <header class="border-surface-200 mb-4 flex items-center justify-between gap-2 border-b pb-3">
            <span class="text-surface-700 text-xl font-semibold">{{ 'companyProfile.itrisSettings' | translate }}</span>
            <img alt="ITRIS" src="assets/images/itris.png" class="integrationImages" />
          </header>
          <div class="p-fluid">
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12 md:col-span-6">
                <p-floatlabel variant="on">
                  <input pInputText type="text" formControlName="itrisUsername" />
                  <label> Itris username </label>
                </p-floatlabel>
              </div>
              <div class="col-span-12 md:col-span-6">
                <p-floatlabel variant="on">
                  <p-password
                    formControlName="itrisPassword"
                    [feedback]="false"
                    [toggleMask]="true"
                    styleClass="w-full"
                  />
                  <label> Itris Password</label>
                </p-floatlabel>
              </div>
            </div>
          </div>
        </section>
      </div>
    </form>
  </p-card>
}

<p-dialog
  [(visible)]="contactPersonDialogOpen"
  [style]="{ width: '25vw' }"
  class="contactPersonDialog"
  [resizable]="false"
  [modal]="true"
  (onHide)="handleContactPersonHide()"
  [header]="'collections.contactPersons.singular' | translate: {}"
>
  <div class="dialogContent p-fluid">
    <form [formGroup]="contactPersonFormGroup" (ngSubmit)="submitContactPersonForm()">
      @let contactPersonForm = contactPersonFormGroup;
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          @let fieldVoornaam = 'voornaam';
          <p-floatlabel variant="on">
            <input [id]="fieldVoornaam" pInputText type="text" [formControlName]="fieldVoornaam" />
            <label [htmlFor]="fieldVoornaam">
              {{ ('fields.firstName' | translate) + (contactPersonForm.controls[fieldVoornaam] | isRequired) }}
              <span class="error">{{ contactPersonForm.controls[fieldVoornaam] | errors | async }}</span>
            </label>
          </p-floatlabel>
        </div>
        <div class="col-span-12">
          @let fieldAchternaam = 'achternaam';
          <p-floatlabel variant="on">
            <input [id]="fieldAchternaam" pInputText type="text" [formControlName]="fieldAchternaam" />
            <label [htmlFor]="fieldAchternaam">
              {{ ('fields.lastName' | translate) + (contactPersonForm.controls[fieldAchternaam] | isRequired) }}
              <span class="error">{{ contactPersonForm.controls[fieldAchternaam] | errors | async }}</span>
            </label>
          </p-floatlabel>
        </div>
        <div class="col-span-12">
          @let fieldFunctie = 'functie';
          <p-floatlabel variant="on">
            <input [id]="fieldFunctie" pInputText type="text" [formControlName]="fieldFunctie" />
            <label [htmlFor]="fieldFunctie">
              {{ ('fields.function' | translate) + (contactPersonForm.controls[fieldFunctie] | isRequired) }}
              <span class="error">{{ contactPersonForm.controls[fieldFunctie] | errors | async }}</span>
            </label>
          </p-floatlabel>
        </div>
        <div class="col-span-12">
          @let fieldMobiel = 'mobiel';
          <p-floatlabel variant="on">
            <input [id]="fieldMobiel" pInputText type="text" [formControlName]="fieldMobiel" />
            <label [htmlFor]="fieldMobiel">
              {{ ('fields.mobile' | translate) + (contactPersonForm.controls[fieldMobiel] | isRequired) }}
              <span class="error">{{ contactPersonForm.controls[fieldMobiel] | errors | async }}</span>
            </label>
          </p-floatlabel>
        </div>
        <div class="col-span-12">
          @let fieldEmail = 'email';
          <p-floatlabel variant="on">
            <input [id]="fieldEmail" pInputText type="text" [formControlName]="fieldEmail" />
            <label [htmlFor]="fieldEmail">
              {{ ('fields.email' | translate) + (contactPersonForm.controls[fieldEmail] | isRequired) }}
              <span class="error">{{ contactPersonForm.controls[fieldEmail] | errors | async }}</span>
            </label>
          </p-floatlabel>
        </div>
      </div>
      <div class="col-span-12 mt-4 flex justify-between gap-4 p-0">
        <p-button
          type="button"
          [label]="'buttons.cancel' | translate"
          iconPos="left"
          severity="secondary"
          [disabled]="savingContactPerson()"
          (onClick)="handleContactPersonHide()"
        >
          <ng-template #icon>
            <fa-icon [icon]="faTimes"></fa-icon>
          </ng-template>
        </p-button>
        <p-button
          [disabled]="isSaveButtonDisabled()"
          [loading]="savingContactPerson()"
          type="submit"
          severity="success"
          [label]="'buttons.saveSingle' | translate"
          iconPos="left"
        >
          <ng-template #icon>
            <fa-icon [icon]="faSave"></fa-icon>
          </ng-template>
          <ng-template #loadingicon>
            <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
          </ng-template>
        </p-button>
      </div>
    </form>
  </div>
</p-dialog>
<p-confirmDialog [style]="{ width: '30vw' }" key="company-confirm-dialog"></p-confirmDialog>
<p-toast position="bottom-right" key="company-profile"></p-toast>
